import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Pagination from "components/ui/pagination/Pagination";
import { MdSettingsBackupRestore } from "react-icons/md";
import RestoreSupplierModal from './modals/RestoreSupplierModal';


export default function DeletedSuppliersTable({data}) {
    const { t } = useTranslation();

    const [showRestoreModal, setShowRestoreModal] = useState(null);
/* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data.length);
        return data.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const suppliersDeletedData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
              <Tr>
                  <Th>#</Th>
                  <Th>{t("pages.suppliers.supplier_name")}</Th>
                  <Th>{t("pages.suppliers.supplier_code")}</Th>
                  <Th>{t("pages.suppliers.contact_name")}</Th>
                  <Th>{t("pages.suppliers.actions")}</Th>
              </Tr>
        </Thead>
        <Tbody>
            {
            suppliersDeletedData?.map((item, index) => (
              <Tr key={index} >
                  <Td> {index + 1} </Td>
                  <Td>
                    {item.SuppliersName}
                  </Td>
                  <Td>{item.SuppliersCode}</Td>
                  <Td>{item.ContactName}</Td>
                  <Td className="activeIcon">
                      <Flex>
                          <Box
                            color="#C53030"
                            _hover={{ color: "#38A169" }}
                            p={2}
                            width={"fit-content"}
                            cursor="pointer"
                            onClick={ () => setShowRestoreModal(item.SuppliersId) }
                          >
                            <MdSettingsBackupRestore size={36} />
                          </Box>
                    </Flex>
                </Td>
              </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
            currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>
    {
      showRestoreModal  &&  (
        <RestoreSupplierModal id={showRestoreModal} onClose={()=>setShowRestoreModal(false)} />
      )
    }
  </>
};
